import React, { useState, useEffect, useMemo } from "react";
import { ActionFx, CreateInflow, Wallet } from "../../pages";
import { WalletController, BusinessController } from "../../controllers";
import { transactionStore, walletStore } from "../../stores";
import { toJS } from "mobx";
import { encodeQueryData } from "../../utils/utils";
import { useNavigate } from "react-router-dom";

const CreateInflowContainer = () => {
  const [loading, setLoading] = useState(false);
  const [createInflowModal, setCreateInflowModal] = useState(false);
  const [reviewInflowModal, setReviewInflowModal] = useState(false);

  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const outflowTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } = WalletController.useGetOutflow(
    outflowTableQuery,
    filterQuery,
    searchQuery
  );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const goToCreateInflow = () => {
    setCreateInflowModal(true);
  };

  const goToReviewInflow = (item) => {
    walletStore.setInflowData(item);
    setReviewInflowModal(true);
  };

  const closeModal = () => {
    setCreateInflowModal(false);
    setReviewInflowModal(false);
  };

  return (
    <CreateInflow
      goToCreateInflow={goToCreateInflow}
      loading={loading}
      closeModal={closeModal}
      createInflowModal={createInflowModal}
      isLoading={isLoading}
      data={data}
      isFetching={isFetching}
      onLimitChange={onLimitChange}
      limit={limit}
      setSearchQuery={setSearchQuery}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      goToReviewInflow={goToReviewInflow}
      reviewInflowModal={reviewInflowModal}
    />
  );
};
export default CreateInflowContainer;
